var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterventionManagementBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 19.4 19.4",
    style: {
      enableBackground: "new 0 0 19.4 19.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#004162;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1,6.6C3.1,6.6,3.1,6.6,3.1,6.6c0.2,0,0.3-0.1,0.4-0.2L4,6l3.2,3.2L2.5,14c-0.4,0.4-0.6,0.9-0.5,1.5 C2,16,2.2,16.6,2.6,17l0,0c0.5,0.5,1.1,0.7,1.7,0.7c0.5,0,1-0.2,1.3-0.5l3.6-3.6l4,4.1c0.3,0.3,0.8,0.5,1.3,0.5 c0.6,0,1.2-0.3,1.7-0.8c0.4-0.4,0.7-0.9,0.7-1.5c0-0.6-0.1-1.1-0.5-1.5l-3.1-3.1c1,0,2-0.4,2.9-1.4l1.3-1.3c1.4-1.4,1-3,0.3-4.5 l-0.3-0.8l-2,2C15.2,5.8,15,6,14.7,6c-0.1,0-0.4,0-0.7-0.3l0,0c-0.3-0.3-0.6-0.7,0.2-1.5l2-2l-0.8-0.3c-1.5-0.6-3.2-1.1-4.5,0.3 L9.6,3.4C8.2,4.8,7.8,6.4,8.5,8c0,0-0.1,0.1-0.1,0.1L8,8.4L4.8,5.2l0.5-0.5c0.1-0.1,0.2-0.3,0.2-0.4c0-0.2-0.1-0.3-0.2-0.4L2.7,2.2 C2.4,2,2.1,2.1,2,2.2L1.1,3.1C0.9,3.3,0.9,3.6,1,3.8l1.7,2.6C2.8,6.5,2.9,6.6,3.1,6.6z M15.7,15.3c0.2,0.2,0.2,0.4,0.2,0.6 c0,0.3-0.2,0.6-0.4,0.8c-0.3,0.3-0.6,0.4-0.9,0.4c-0.2,0-0.4,0-0.5-0.2l-5-5l1.6-1.6L15.7,15.3z M9.1,8.9c0.1-0.1,0.1-0.1,0.2-0.1 L10,8.5L9.7,7.9C9,6.6,9.2,5.3,10.4,4.1l1.3-1.3c0.6-0.6,1.4-0.8,2.6-0.4l-0.9,0.8c-1.4,1.4-0.7,2.5-0.2,3.1l0,0 c0.6,0.6,1.3,0.7,1.7,0.6c0.5-0.1,0.9-0.4,1.4-0.8l0.8-0.9c0.4,1.2,0.3,1.9-0.4,2.6l-1.3,1.3c-1.1,1.1-2.3,1.3-3.6,0.6l-0.4-0.4 c-0.2-0.2-0.4-0.3-0.6-0.4l-0.3-0.1l-1,1L8.8,9.2L9.1,8.9z M8.7,10.7l-1,1L7.8,12c0.1,0.2,0.2,0.5,0.4,0.6l0.2,0.2l-3.6,3.6 c-0.3,0.3-1,0.3-1.4-0.2l0,0C3.2,16,3.1,15.7,3,15.4c0-0.3,0-0.5,0.2-0.6L8,10L8.7,10.7z M2.4,3.3L4,4.4L3.2,5.2L2.2,3.6L2.4,3.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterventionManagementBlue);
export default __webpack_public_path__ + "static/media/intervention_management_Blue.604ed2eaaa72ed14e34e8e822e1da5e0.svg";
export { ForwardRef as ReactComponent };